import React, { useState } from "react";
import PageShell from "../dashboard/PageShell";

interface ProductTypeIIIBookFormData {
  bookTitle: string;
  mainAuthorSelect: string;
  mainAuthorName: string;
  coAuthor: string;
  publisher: string;
  publicationMonth: string;
  publicationYear: string;
  transferInfo: boolean;
  attachments: File[];
}

const AddProductTypeIIIBook: React.FC = () => {
  const [formData, setFormData] = useState<ProductTypeIIIBookFormData>({
    bookTitle: "",
    mainAuthorSelect: "Lê Anh Tuấn",
    mainAuthorName: "Thượng tá, VS. ThS Lê Anh Tuân",
    coAuthor: "",
    publisher: "",
    publicationMonth: "",
    publicationYear: "",
    transferInfo: false,
    attachments: [],
  });

  const handleInputChange = (
    field: keyof ProductTypeIIIBookFormData,
    value: string | boolean | File[]
  ) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleFileSelect = (files: FileList | null) => {
    if (files) {
      const newFiles = Array.from(files);
      handleInputChange("attachments", [...formData.attachments, ...newFiles]);
    }
  };

  const handleRemoveFile = (index: number) => {
    const updated = formData.attachments.filter((_, i) => i !== index);
    handleInputChange("attachments", updated);
  };

  const handleSave = () => {
    console.log("Saving product type III book:", formData);
    // TODO: Implement save functionality
  };

  const handleCancel = () => {
    window.history.back();
  };

  return (
    <PageShell title="Thêm sách chuyên khảo">
      <div className="space-y-6">
        <div className="mb-6">
          <h1 className="text-xl font-semibold text-gray-800">
            Thêm sách chuyên khảo
          </h1>
        </div>

        <div className="bg-white rounded-lg">
          <form onSubmit={(e) => e.preventDefault()} className="space-y-6">
            {/* Tên sách */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Tên sách <span className="text-red-500">(*)</span>
              </label>
              <input
                type="text"
                value={formData.bookTitle}
                onChange={(e) => handleInputChange("bookTitle", e.target.value)}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Nhập tên sách..."
              />
            </div>

            {/* Thông tin tác giả */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* Chọn tác giả chính */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Chọn tác giả chính <span className="text-red-500">(*)</span>
                </label>
                <select
                  value={formData.mainAuthorSelect}
                  onChange={(e) =>
                    handleInputChange("mainAuthorSelect", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="Lê Anh Tuấn">Lê Anh Tuấn</option>
                  <option value="Nguyễn Văn A">Nguyễn Văn A</option>
                  <option value="Trần Thị B">Trần Thị B</option>
                </select>
              </div>

              {/* Tên tác giả chính */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Tên tác giả chính <span className="text-red-500">(*)</span>
                </label>
                <input
                  type="text"
                  value={formData.mainAuthorName}
                  onChange={(e) =>
                    handleInputChange("mainAuthorName", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              {/* Đồng tác giả */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Đồng tác giả
                </label>
                <input
                  type="text"
                  value={formData.coAuthor}
                  onChange={(e) =>
                    handleInputChange("coAuthor", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập đồng tác giả..."
                />
              </div>
            </div>

            {/* Thông tin xuất bản */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* Nhà xuất bản */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nhà xuất bản
                </label>
                <input
                  type="text"
                  value={formData.publisher}
                  onChange={(e) =>
                    handleInputChange("publisher", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập nhà xuất bản..."
                />
              </div>

              {/* Tháng */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Tháng
                </label>
                <select
                  value={formData.publicationMonth}
                  onChange={(e) =>
                    handleInputChange("publicationMonth", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">- Chọn -</option>
                  {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                    <option key={month} value={String(month).padStart(2, "0")}>
                      {String(month).padStart(2, "0")}
                    </option>
                  ))}
                </select>
              </div>

              {/* Năm xuất bản */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Năm xuất bản
                </label>
                <select
                  value={formData.publicationYear}
                  onChange={(e) =>
                    handleInputChange("publicationYear", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">- Chọn -</option>
                  {Array.from(
                    { length: 10 },
                    (_, i) => new Date().getFullYear() - i
                  ).map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Checkbox chuyển thông tin */}
            <div className="flex items-center">
              <input
                id="transfer-info"
                type="checkbox"
                checked={formData.transferInfo}
                onChange={(e) =>
                  handleInputChange("transferInfo", e.target.checked)
                }
                className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              />
              <label
                htmlFor="transfer-info"
                className="ml-2 block text-sm text-gray-900"
              >
                Chuyển thông tin bài báo đến Mục bài báo đã công bố
              </label>
            </div>

            {/* File đính kèm */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                File đính kèm
              </label>
              <div className="flex items-center space-x-4">
                <input
                  type="file"
                  multiple
                  onChange={(e) => handleFileSelect(e.target.files)}
                  className="hidden"
                  id="book-file-upload"
                  accept=".pdf,.doc,.docx,.jpg,.png"
                />
                <label
                  htmlFor="book-file-upload"
                  className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 cursor-pointer transition-colors"
                >
                  Choose Files
                </label>
                <span className="text-sm text-gray-500">
                  {formData.attachments.length > 0
                    ? `${formData.attachments.length} file${
                        formData.attachments.length > 1 ? "s" : ""
                      } chosen`
                    : "No file chosen"}
                </span>
              </div>

              {formData.attachments.length > 0 && (
                <div className="mt-4 space-y-2 max-h-60 overflow-y-auto">
                  {formData.attachments.map((file, index) => (
                    <div key={index} className="bg-white rounded-lg p-3">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-3">
                          <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                            <svg
                              className="w-4 h-4 text-blue-600"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                              />
                            </svg>
                          </div>
                          <div>
                            <p className="text-sm font-medium text-gray-900">
                              {file.name}
                            </p>
                            <p className="text-xs text-gray-500">
                              {(file.size / 1024).toFixed(1)} KB
                            </p>
                          </div>
                        </div>
                        <button
                          onClick={() => handleRemoveFile(index)}
                          className="text-red-500 hover:text-red-700 hover:bg-red-50 p-1 rounded transition-colors flex-shrink-0"
                          title="Xóa file"
                        >
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </form>
        </div>

        <div className="flex items-center justify-end gap-2">
          <button
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded hover:bg-gray-50"
            onClick={handleCancel}
          >
            Hủy
          </button>
          <button
            className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded text-sm font-medium"
            onClick={handleSave}
          >
            Lưu dữ liệu
          </button>
        </div>
      </div>
    </PageShell>
  );
};

export default AddProductTypeIIIBook;
